<template lang="pug">
.row.bs-wizard(
    :class="{ 'completed': status == 2 }"
)
    .col-xs-3.bs-wizard-step.complete
        .text-center.bs-wizard-stepnum Create
        .progress
            .progress-bar
        a.bs-wizard-dot
        .bs-wizard-info.text-center

    .col-xs-3.bs-wizard-step(
        :class="{ 'complete': status >= 0 && status !== null, 'disabled': status == null }"
    )
        .text-center.bs-wizard-stepnum Editing
        .progress
            .progress-bar
        a.bs-wizard-dot
        .bs-wizard-info.text-center


    .col-xs-3.bs-wizard-step(
        :class="{ 'complete': status >= 1, 'disabled': status < 1 }"
    )
        .text-center.bs-wizard-stepnum Ordered
        .progress
            .progress-bar
        a.bs-wizard-dot
        .bs-wizard-info.text-center

    .col-xs-3.bs-wizard-step(
        :class="{ 'complete': status == 2, 'disabled': status == null || status < 2 }"
    )
        .text-center.bs-wizard-stepnum Received
        .progress
            .progress-bar
        a.bs-wizard-dot
        .bs-wizard-info.text-center
</template>

<script>
export default {
    props: {
        status: {
            type: Number,
            default: null,
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/purchase-order/purchase-order-step.vue